import { useTranslation } from 'next-i18next';
import { useSelector } from '../../../../../../reduxToolkit/typedRedux';
import VyButton from '../../../../../common/VyButton';
import VyModal from '../../../../../common/VyModal';

interface PostCallModalProps {
  open: boolean;
  onRateCall: (rating: number) => void;
  onContactAdd: () => void;
  onNext: () => void;
  onEndMatching: () => void;
  ratingValue: number;
}

export const PostCallModal = (props: PostCallModalProps) => {
  const { open, onRateCall, onContactAdd, ratingValue, onNext, onEndMatching } = props;

  const event = useSelector((state) => state.common.event);

  const { t } = useTranslation();

  return (
    <VyModal open={open}>
      {() => (
        <div className="flex flex-col justify-center items-center ">
          {/*<Typography>Please rate the quality of the call</Typography>
          <div className="flex">
            {[1, 2, 3, 4, 5].map((i) => {
              return <IconButton onClick={() => onRateCall(i)}>{ratingValue >= i ? <MdStar color={event?.template.mainColor} /> : <MdStar />}</IconButton>;
            })}
          </div>
          <Typography>Would you like to add dude to your chats to call later?</Typography>

          <VyButton className="w-full my-2">Add to contacts</VyButton>*/}
          <VyButton className="w-full my-2" onClick={onNext}>
            {t('meeting:speeddating.connect-next-call')}
          </VyButton>
          <VyButton className="w-full my-2" onClick={onEndMatching}>
            {t('meeting:speeddating.close-matching')}
          </VyButton>
        </div>
      )}
    </VyModal>
  );
};
